import { useEffect } from "react";
import { Pagination } from "@sscs/types";

type UseCheckPaginationPageProps = {
  matchCount?: number;
  itemLength?: number;
  currentPage: number;
  itemsPerPage: number;
  handlePaginationChange: (pagination: Pagination) => void;
};

/**
 * Used to check if a delete action in a paginated table has resulted in no records being shown on the current page. If so, it steps back a page.
 */
const useCheckPaginationPage = ({
  matchCount,
  itemLength,
  currentPage,
  itemsPerPage,
  handlePaginationChange,
}: UseCheckPaginationPageProps) => {
  // after a delete action completes, we might need to move back a couple of pages...
  useEffect(() => {
    if (matchCount && matchCount > 0 && itemLength === 0 && currentPage > 1) {
      const lastPage = Math.ceil(matchCount / itemsPerPage);

      handlePaginationChange({
        currentPage: lastPage,
        itemsPerPage,
      });
    }
    // we don't want to track the currentPage as it will change with other pagination actions taking place, causing a loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchCount, itemLength, itemsPerPage, handlePaginationChange]);
};

export default useCheckPaginationPage;
